import { SwiperProps } from 'swiper/react';
import ImageCardAmsterdam from '../../../../images/cities/cards/amsterdam-1x.webp';
import ImageCardAmsterdam2x from '../../../../images/cities/cards/amsterdam-2x.webp';
import ImageCardAmsterdam3x from '../../../../images/cities/cards/amsterdam-3x.webp';
import ImageAnnecyHighlited from '../../../../images/cities/cards/annecy-hightlited-1x.webp';
import ImageAnnecyHighlited2x from '../../../../images/cities/cards/annecy-hightlited-2x.webp';
import ImageAnnecyHighlited3x from '../../../../images/cities/cards/annecy-hightlited-3x.webp';
import ImageCardCannes from '../../../../images/cities/cards/cannes-1x.webp';
import ImageCardCannes2x from '../../../../images/cities/cards/cannes-2x.webp';
import ImageCardCannes3x from '../../../../images/cities/cards/cannes-3x.webp';
import ImageCardLesArcs from '../../../../images/cities/cards/lesarcs-1x.webp';
import ImageCardLesArcs2x from '../../../../images/cities/cards/lesarcs-2x.webp';
import ImageCardLesArcs3x from '../../../../images/cities/cards/lesarcs-3x.webp';
import ImageCardLondon from '../../../../images/cities/cards/londres-1x.webp';
import ImageCardLondon2x from '../../../../images/cities/cards/londres-2x.webp';
import ImageCardLondon3x from '../../../../images/cities/cards/londres-3x.webp';
import ImageCardMarseille from '../../../../images/cities/cards/marseille-1x.webp';
import ImageCardMarseille2x from '../../../../images/cities/cards/marseille-2x.webp';
import ImageCardMarseille3x from '../../../../images/cities/cards/marseille-3x.webp';
import ImageMarseilleHighlited from '../../../../images/cities/cards/marseille-hightlited-1x.webp';
import ImageMarseilleHighlited2x from '../../../../images/cities/cards/marseille-hightlited-2x.webp';
import ImageMarseilleHighlited3x from '../../../../images/cities/cards/marseille-hightlited-3x.webp';
import ImageCardValDIsere from '../../../../images/cities/cards/valdisere-1x.webp';
import ImageCardValDIsere2x from '../../../../images/cities/cards/valdisere-2x.webp';
import ImageCardValDIsere3x from '../../../../images/cities/cards/valdisere-3x.webp';

export interface IHighlightedCity {
  image: string;
  image2x?: string;
  image3x?: string;
  name: string;
  url: string;
}

export const HIGHLIGHTED_CITIES: IHighlightedCity[] = [
  {
    image: ImageMarseilleHighlited,
    image2x: ImageMarseilleHighlited2x,
    image3x: ImageMarseilleHighlited3x,
    name: 'Marseille',
    url: '/city/marseille',
  },
  {
    image: ImageAnnecyHighlited,
    image2x: ImageAnnecyHighlited2x,
    image3x: ImageAnnecyHighlited3x,
    name: 'Annecy',
    url: '/city/annecy',
  },
];

export const SLIDER_PROPS: SwiperProps = {
  breakpoints: {
    489: {
      slidesPerView: 1.5,
    },

    661: {
      slidesPerView: 2,
    },
    768: {
      slidesPerView: 2.5,
    },
    992: {
      slidesPerView: 1.5,
    },
    1143: {
      slidesPerView: 2,
    },
    1352: {
      slidesPerView: 2.5,
    },
  },
  slidesPerView: 1,
  spaceBetween: 24,
  loop: true,
};

export interface IDestination {
  name: string;
  price: number;
  url: string;
  image: string;
  image2x?: string;
  image3x?: string;
}

export const DESTINATIONS: IDestination[] = [
  {
    name: 'Marseille',
    price: 18,
    url: '/city/marseille',
    image: ImageCardMarseille,
    image2x: ImageCardMarseille2x,
    image3x: ImageCardMarseille3x,
  },
  {
    name: "Val d'Isère",
    price: 15,
    url: '/city/val-disere',
    image: ImageCardValDIsere,
    image2x: ImageCardValDIsere2x,
    image3x: ImageCardValDIsere3x,
  },
  {
    name: 'Amsterdam',
    price: 9,
    url: '/city/amsterdam',
    image: ImageCardAmsterdam,
    image2x: ImageCardAmsterdam2x,
    image3x: ImageCardAmsterdam3x,
  },
  {
    name: 'Les Arcs',
    price: 20,
    url: '/city/les-arcs',
    image: ImageCardLesArcs,
    image2x: ImageCardLesArcs2x,
    image3x: ImageCardLesArcs3x,
  },

  {
    name: 'Londres',
    price: 20,
    url: '/city/london',
    image: ImageCardLondon,
    image2x: ImageCardLondon2x,
    image3x: ImageCardLondon3x,
  },
  {
    name: 'Cannes',
    price: 15,
    url: '/city/cannes',
    image: ImageCardCannes,
    image2x: ImageCardCannes2x,
    image3x: ImageCardCannes3x,
  },
];
